// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  application:
  {
    name: 'angular-starter',
    angular: 'Angular 11.2.4',
    bootstrap: 'Bootstrap 5.0.0',
    fontawesome: 'Font Awesome 5.15.2',
    typescript:  '4.2.0' 
  },
  config: {
    rootUrl: 'http://dcdapi.ssasoft.com/',
    // BASE_API_URL:  'https://dcdapi.ssasoft.com/api/',
    BASE_API_URL: 'https://pndapi.drycleandepotdelivers.com/api/'
    //https://dcdapi.ssasoft.com/
  }

};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
